module.exports = __webpack_public_path__ + "img/12.b8b95a0a.jpg";